import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import CtitemDashboard from 'components/ctitem/CtitemDashboard';
import { getCtitemInfoByCitedAPI } from 'components/ctitem/CtitemAPI';
import { setCtitemDashboardCtitemList } from 'store/slice/PharmaSlice';

export default function CompositionMgmtActionImpl(){
    const dispath = useDispatch();
    const {compositiontemplateObj} = useSelector((state)=>state.pharmaslice.compositiontemplateDashboard);


    useEffect(()=>{
        getCtitemInfoByCitedAPI(compositiontemplateObj.id,getCTitemListSuccess, getCTitemListFailure )

    },[])

    const getCTitemListSuccess = (respObj) =>{
        console.log('respObj=>'+JSON.stringify(respObj));
        dispath(setCtitemDashboardCtitemList(respObj));
    }
    const getCTitemListFailure = () =>{

    }
    return (
        <>
        <CtitemDashboard/>
        </>
    )
}